import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { UserDetailsLayout } from './UserDetailsLayout';
import { fetchUsersList } from '../../store/identyti/actions/users';
import { useIdentity } from '../../store/identyti/identity-context';
import { Spinner } from '../Spinner';

interface Props {
	children: JSX.Element
}

export const UserDetails: FC<Props> = (props) => {
	const { children } = props;
	const { search } = useLocation();
	const { userId } = useParams();
	const { t } = useTranslation();

	const searchParams = new URLSearchParams(search);
	const userEmail = searchParams.get('email')?.replace(' ', '+');

	const {
		identityState: { isUserListLoading },
		dispatch
	} = useIdentity();


	useEffect(() => {
		const searchParams = {
			filterBy: 'email',
			query: userEmail,
		};
		void fetchUsersList({ dispatch, searchParams });
	}, []);

	if (isUserListLoading) {
		return (
			<div className="card w-100 h-100">
				<div className="card-body">
					<Spinner pageLoader/>
				</div>
			</div>
		);
	}

	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: t('MENU.USERS'),
						path: '/users',
						isSeparator: false,
						isActive: false
					},
					{
						title: '',
						path: '',
						isSeparator: true,
						isActive: false
					}
				]}
			>
				{userId}
			</PageTitle>
			<UserDetailsLayout/>
			{children}
		</>
	);
};